import { FontDto, FontStyleDto } from "@repo/api/font";
import { getFontWeights, getFontStyles } from "@repo/api/utils/font";
import { FontCategoryFilter } from "./FontFilters";

export const categoryLabels: Record<FontCategoryFilter, string> = {
  ALL: "All Categories",
  "sans-serif": "Sans Serif",
  serif: "Serif",
  display: "Display",
  handwriting: "Handwriting",
  monospace: "Monospace",
};

export const fontWeightLabels: Record<number, string> = {
  100: "Thin",
  200: "Extra Light",
  300: "Light",
  400: "Normal",
  500: "Medium",
  600: "Semi Bold",
  700: "Bold",
  800: "Extra Bold",
  900: "Black",
  950: "Extra Black",
};

export function pickClosestWeight(
  weights: number[],
  preferred: number,
): number {
  if (weights.length === 0) return preferred;
  if (weights.includes(preferred)) return preferred;

  return weights.reduce((closest, weight) =>
    Math.abs(weight - preferred) < Math.abs(closest - preferred)
      ? weight
      : closest,
  );
}

export function pickStyle(
  styles: FontStyleDto[],
  preferred: FontStyleDto,
): FontStyleDto {
  if (styles.length === 0) return preferred;
  if (styles.includes(preferred)) return preferred;

  return styles.includes("normal") ? "normal" : styles[0]!;
}

export function getFontWeightOptions(
  font: FontDto | undefined,
  currentWeight: number,
): number[] {
  const weights = font ? getFontWeights(font.metadata) : [];

  return weights.length > 0 ? weights : [currentWeight];
}

// Styles are scoped to the active weight so we never offer an italic (or
// upright) cut the font doesn't actually ship for that weight.
export function getFontStyleOptions(
  font: FontDto | undefined,
  currentStyle: FontStyleDto,
  weight?: number,
): FontStyleDto[] {
  const styles = font ? getFontStyles(font.metadata, weight) : [];

  return styles.length > 0 ? styles : [currentStyle];
}
